// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-pages----CreditsPage-module---wrapper---1IiWz"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/CreditsPage.module.css
// module id = 637
// module chunks = 190176442836051